import { __extends } from "tslib";
import { ASError } from '@awayfl/avm2';
var StackOverflowError = /** @class */ (function (_super) {
    __extends(StackOverflowError, _super);
    function StackOverflowError(message, id) {
        if (message === void 0) { message = ''; }
        if (id === void 0) { id = 0; }
        return _super.call(this, message, id) || this;
    }
    // Called whenever the class is initialized.
    StackOverflowError.classInitializer = null;
    // List of static symbols to link.
    StackOverflowError.classSymbols = null; // [];
    // List of instance symbols to link.
    StackOverflowError.instanceSymbols = null; // [];
    return StackOverflowError;
}(ASError));
export { StackOverflowError };
